import React from 'react';

export type SearchHeaderProps = {
    leftFields?: React.ReactNode;
    rightFields?: React.ReactNode;
};

const SearchHeader: React.FC<SearchHeaderProps> = function ({ leftFields, rightFields }) {
    return (
        <div className={`header-search`}>
            <div className="header-search__left">{leftFields}</div>
            <div className="header-search__right">{rightFields}</div>
        </div>
    );
};

export default SearchHeader;
